module.exports = __webpack_public_path__ + "static/media/PLAYER5.df96edb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/PLAYER5.png
// module id = 271
// module chunks = 0